import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserRoleOptions } from "../../constants/userRole";

const FacebookAuthModal = ({ isOpen, onClose }) => {
  const [isLoginView, setIsLoginView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Form State
  const [formData, setFormData] = useState({
    username: '', // email or phone
    password: '',
    name: '',
    age: '',
    role: '',
    conPassword: '',
  });

  if (!isOpen) return null;

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Point to the new hybrid endpoint
      const response = await axios.post(`${process.env.REACT_APP_MAIN_SITE_URL}/facebook-login`, {
        username: formData.username,
        password: formData.password,
      });
      
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("user_id", response.data.data.user_id);
      onClose();
      navigate("/post"); // Redirect to post or profile
    } catch (err) {
      setError(err.response?.data?.message || "Authentication failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    
    let email = null;
    let phone = null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10,}$/;

    if (emailRegex.test(formData.username)) {
      email = formData.username;
    } else if (phoneRegex.test(formData.username)) {
      phone = formData.username;
    } else {
      return setError("Please enter a valid email or phone number");
    }

    if (formData.password !== formData.conPassword) {
      return setError("Passwords do not match");
    }

    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_MAIN_SITE_URL}/register`, {
        name: formData.name,
        email,
        phone,
        age: formData.age,
        role: formData.role,
        password: formData.password,
        password_confirmation: formData.conPassword,
      });

      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("user_id", response.data.data.user_id);
      onClose();
      navigate("/post", { state: { userId: response.data.data.user_id } });
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <style>
        {`
          .fb-input {
            color: #1d2129 !important;
            background-color: #ffffff !important;
            border: 1px solid #dddfe2 !important;
            border-radius: 6px !important;
            padding: 14px 16px !important;
            font-size: 16px !important;
            width: 100% !important;
            box-sizing: border-box !important;
            outline: none !important;
            margin-bottom: 0 !important;
          }
          .fb-input::placeholder {
            color: #8d949e !important;
            opacity: 1 !important;
          }
          .fb-input:focus {
            border-color: #1877f2 !important;
            box-shadow: 0 0 0 2px #e7f3ff !important;
          }
          .fb-select {
            color: #1d2129 !important;
            background-color: #ffffff !important;
            border: 1px solid #dddfe2 !important;
            border-radius: 6px !important;
            padding: 14px 16px !important;
            font-size: 16px !important;
            width: 100% !important;
            box-sizing: border-box !important;
            outline: none !important;
            appearance: none;
          }
          .fb-close-btn {
            background: none !important;
            border: none !important;
            font-size: 28px !important;
            cursor: pointer !important;
            color: #606770 !important;
            line-height: 1 !important;
            padding: 0 !important;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 32px !important;
            height: 32px !important;
            border-radius: 50% !important;
          }
          .fb-close-btn:hover {
            background-color: #f2f2f2 !important;
          }
        `}
      </style>
      <div style={styles.modal}>
        {/* Header */}
        <div style={styles.header}>
          <h2 style={styles.title}>Facebook</h2>
          <button onClick={onClose} className="fb-close-btn">&times;</button>
        </div>

        {/* Content */}
        <div style={styles.content}>
          {error && <div style={styles.error}>{error}</div>}

          {isLoginView ? (
            <form onSubmit={handleLogin} style={styles.form}>
              <p style={styles.subtitle}>Log Into Facebook</p>
              <input type="text" name="username" placeholder="Email or Phone Number" value={formData.username} onChange={handleChange} className="fb-input" required />
              <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} className="fb-input" required />
              <button type="submit" style={styles.loginBtn} disabled={loading}>{loading ? "Logging in..." : "Log In"}</button>
              
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <a href="#" onClick={(e) => e.preventDefault()} style={{ color: '#1877f2', textDecoration: 'none', fontSize: '14px' }}>Forgotten password?</a>
              </div>

              <div style={styles.divider}></div>
              
              <button type="button" onClick={() => setIsLoginView(false)} style={styles.registerBtn}>Create New Account</button>
            </form>
          ) : (
            <form onSubmit={handleRegister} style={styles.form}>
              <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                <h3 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#1c1e21' }}>Sign Up</h3>
                <p style={styles.smallText}>It's quick and easy.</p>
              </div>
              
              <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} className="fb-input" required />
              <input type="text" name="username" placeholder="Email or Phone Number" value={formData.username} onChange={handleChange} className="fb-input" required />
              
              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <input type="number" name="age" placeholder="Age" min="18" max="120" value={formData.age} onChange={handleChange} className="fb-input" required />
                </div>
                <div style={{ flex: 1 }}>
                  <select name="role" value={formData.role} onChange={handleChange} className="fb-select" required>
                    <option value="">Category</option>
                    {UserRoleOptions.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                  </select>
                </div>
              </div>

              <input type="password" name="password" placeholder="New Password" value={formData.password} onChange={handleChange} className="fb-input" required minLength="8" />
              <input type="password" name="conPassword" placeholder="Confirm Password" value={formData.conPassword} onChange={handleChange} className="fb-input" required minLength="8" />
              
              <p style={styles.terms}>By clicking Sign Up, you agree to our Terms, Data Policy and Cookies Policy.</p>
              
              <div style={{ textAlign: 'center' }}>
                <button type="submit" style={styles.registerBtnSubmit} disabled={loading}>{loading ? "Signing up..." : "Sign Up"}</button>
              </div>
              <p style={{ textAlign: 'center', marginTop: '15px' }}>
                <a href="#" onClick={(e) => { e.preventDefault(); setIsLoginView(true); }} style={{ color: '#1877f2', textDecoration: 'none', fontSize: '14px', fontWeight: 'bold' }}>Already have an account?</a>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999 },
  modal: { width: '400px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)', overflow: 'hidden', fontFamily: 'Helvetica, Arial, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', borderBottom: '1px solid #dadde1' },
  title: { color: '#1877f2', fontSize: '28px', fontWeight: 'bold', margin: 0, letterSpacing: '-0.5px' },
  content: { padding: '20px' },
  error: { color: 'white', backgroundColor: '#e53935', padding: '10px', borderRadius: '4px', marginBottom: '15px', fontSize: '14px', textAlign: 'center' },
  form: { display: 'flex', flexDirection: 'column', gap: '12px' },
  subtitle: { fontSize: '18px', margin: '0 0 10px 0', textAlign: 'center', color: '#1c1e21' },
  smallText: { fontSize: '15px', color: '#606770', margin: '0' },
  loginBtn: { backgroundColor: '#1877f2', color: '#fff', fontSize: '20px', fontWeight: 'bold', padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer', marginTop: '10px', width: '100%' },
  registerBtn: { backgroundColor: '#42b72a', color: '#fff', fontSize: '16px', fontWeight: 'bold', padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer', width: '70%', margin: '0 auto', display: 'block' },
  registerBtnSubmit: { backgroundColor: '#42b72a', color: '#fff', fontSize: '18px', fontWeight: 'bold', padding: '10px 40px', border: 'none', borderRadius: '6px', cursor: 'pointer', marginTop: '10px' },
  divider: { borderBottom: '1px solid #dadde1', margin: '20px 0' },
  terms: { fontSize: '11px', color: '#777', margin: '10px 0', lineHeight: '1.3' }
};

export default FacebookAuthModal;
